<template>
  <div>
    <van-action-sheet v-model="showYear" :actions="actions"
                      @select="onSelect" @close="onClose" close-on-click-action
    />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showYear: this.show,
      actions: []
    }
  },
  watch: {
    show: function(value) {
      this.showYear = value
    }
  },
  created() {
    const currYear = new Date().getFullYear()
    for (let i = 2014; i <= currYear; i++) {
      this.actions.push({
        name: i + ' 年',
        value: i
      })
    }
  },
  methods: {
    onSelect(year) {
      this.$emit('change', this.showYear, year)
    },
    onClose() {
      this.showYear = false
      this.$emit('change', this.showYear)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commons/change-year.vue